<!--  -->
<template>
    <div class='bg box box_v'>
        <div class="title1">业务办理实时推送</div>
        <div class="tr box">
            <div class="td1">时间</div>
            <div class="td2">办理人姓名</div>
            <div class="td3 box_f1">业务类型</div>
            
        </div>
        <div class="tr_item box_f1 box" v-for="(item,index) in topData" :key="index">
            <div class="td1">{{item.dateTime}}</div>
            <div class="td2">{{item.userName}}</div>
            <div class="td3 box_f1">{{item.estateTypeName}}件</div>
            
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    props:['communityId'],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            topData:[],
            communityIds:1
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        communityId:{
            handler(newVal){
                if(this.communityIds != newVal){
                    this.communityIds = newVal;
                    this.getData(this.communityIds)
                }
            },
            deep:true
        }
    },
    //方法集合
    methods: {
        getData(communityId){
            this.$get(this.urlobj.estateNewest10,{
                communityId:communityId
            }).then(res=>{
                this.topData = res.rows.splice(0,8).map(item=>{
                    return{
                        ...item,
                        userName:item.userName.replace(/(?<=.)./g, '*'),
                    }
                    
                })
            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getData(this.communityIds)
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.bg{
    width: 100%;
    background-image: url('../../../../assets/images/monitorpy/rightup.png');
    background-size: 100% 100%;
    height:100%;
}
.title1{
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin:30px 0 0 50px
}
.tr{
    color:#0EFCFF;
    margin:10px;
    height: 38px;
    line-height:38px;
    background: linear-gradient(90deg, rgba(21, 144, 245, 0) 0%, #0067BC 48%, rgba(21, 144, 245, 0) 100%);
}
.td1{
    width:180px;
    text-align: center;
    color:#0EFCFF;
}
.td2{
    color:#0EFCFF;
    text-align: center;
    width:100px;
}
.td3{
    
    text-align: center;
}
.td4{
    width:60px;
}
.tr_item{
    //line-height: 45px;
    margin:0 10px;
    .td3{
        font-size: 14px;
        font-style: italic;
        font-weight:bold;
        background: linear-gradient(180deg, #F5A418 0%, #EA7A24 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
}
</style>